import { render, staticRenderFns } from "./FPFab.vue?vue&type=template&id=61cb20ce"
import script from "./FPFab.vue?vue&type=script&lang=js"
export * from "./FPFab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports